// src/services/api/organization-currency.js

import { apiInstance as api } from './index';

/**
 * Get organization currency settings
 */
export const getOrganizationCurrencySettings = async (orgId) => {
    const response = await api.get(`/organizations/${orgId}/settings/currency`);
    return response.data;
};

/**
 * Update organization display currency
 */
export const updateOrganizationDisplayCurrency = async (orgId, displayCurrency) => {
    const response = await api.put(`/organizations/${orgId}/settings/currency`, {
        display_currency: displayCurrency
    });
    return response.data;
};

/**
 * Convert amount between currencies
 */
export const convertCurrency = async (orgId, amount, fromCurrency, toCurrency, conversionDate = null) => {
    const response = await api.post(`/organizations/${orgId}/currency/convert`, {
        amount,
        from_currency: fromCurrency,
        to_currency: toCurrency,
        conversion_date: conversionDate
    });
    return response.data;
};

/**
 * Get supported currencies
 */
export const getSupportedCurrencies = async (orgId) => {
    const settings = await getOrganizationCurrencySettings(orgId);
    return settings.supported_currencies || [];
};